import handleLocale from "./LocaleSwitch";
import { getLocale } from "./locale/locale";

export const localeISO = handleLocale(getLocale());
